/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputQuestion/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import BooleanInput from './BooleanInput/index'
import DateInput from './DateInput/index'
import ListInput from './ListInput/index'
import MultiChoiceCustomInput from './MultiChoiceCustomInput/index'
import No from './No/index'
import NumberInput from './NumberInput/index'
import React from 'react'
import SelectorCustomInput from './SelectorCustomInput/index'
import SelectorInput from './SelectorInput/index'
import TextInput from './TextInput/index'
import TextMultiLineInput from './TextMultiLineInput/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaInputQuestion({
  children,
  viewPath = "/DesignSystem/TysiaInputQuestion",
  size,
  disabled,
  maxWidth,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  isToggle,
  showAlert = true
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let questionTypeValueData = fromData.useDataFormat({ viewPath,
context: 'question',
path: 'type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: questionTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'BooleanInput'}>
<BooleanInput
  viewPath={`${viewPath}/BooleanInput`}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DateInput'}>
<DateInput
  viewPath={`${viewPath}/DateInput`}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ListInput'}>
<ListInput
  viewPath={`${viewPath}/ListInput`}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
 isToggle={isToggle}
 showAlert={showAlert}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NumberInput'}>
<NumberInput
  viewPath={`${viewPath}/NumberInput`}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SelectorInput'}>
<SelectorInput
  viewPath={`${viewPath}/SelectorInput`}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'SelectorCustomInput'}>
<SelectorCustomInput
  viewPath={`${viewPath}/SelectorCustomInput`}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MultiChoiceCustomInput'}>
<MultiChoiceCustomInput
  viewPath={`${viewPath}/MultiChoiceCustomInput`}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TextInput'}>
<TextInput
  viewPath={`${viewPath}/TextInput`}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TextMultiLineInput'}>
<TextMultiLineInput
  viewPath={`${viewPath}/TextMultiLineInput`}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}